import { Pipe, PipeTransform } from '@angular/core';
import {
    ReverseAdvanceOrderType, Instrument, OrderMode, OrderType, OrderStatusAcronym, ReverseOrderValidityMapping, ProductType
} from 'sharedweb/app.structs';

@Pipe({
    name: 'instrumentType'
})
export class InstrumentTypePipe implements PipeTransform {
    transform(value: string): string {
        return Instrument[value];
    }
}

@Pipe({
    name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {
    transform(value: string): string {
        return OrderStatusAcronym[value];
    }
}

@Pipe({
    name: 'orderMode'
})
export class OrderModePipe implements PipeTransform {
    transform(value: number): string {
        return OrderMode[value];
    }
}

@Pipe({
    name: 'orderModeString'
})
export class OrderModePipeString implements PipeTransform {
    transform(value: string): string {
        return OrderMode[value];
    }
}

@Pipe({
    name: 'orderValidity'
})
export class OrderValidityPipe implements PipeTransform {
    transform(value: string): string {
        return ReverseOrderValidityMapping[value];
    }
}

@Pipe({
    name: 'orderType'
})
export class OrderTypePipe implements PipeTransform {
    transform(value: string): string {
        return OrderType[value] || ReverseAdvanceOrderType[value];
    }
}

@Pipe({
    name: 'productType'
})
export class ProductTypePipe implements PipeTransform {
    transform(value: string): string {
        return ProductType[value] ? ProductType[value] : value;
    }
}
